<template>
  <div class="published-date">{{dateWithTimezone}}</div>
</template>

<script>
  import dateFormatter from 'components/mixins/dateFormatter'
  import get from 'lodash/get'

  export default {
    name: 'field-date',
    props: ['node'],
    mixins: [dateFormatter],
    data() {
      return {
        dateWithTimezone: '',
      }
    },
    methods: {
      date() {
        const published = get(this, 'node.published') || get(this, 'node.created')
        return this.articleDateFormatter(published)
      },
    },
    created() {
      // This timestamp is for SSR
      this.dateWithTimezone = this.date()
    },
    mounted() {
      // Re-generate timestamp with client timezone
      this.dateWithTimezone = this.date()
    },
  }
</script>

<style scoped lang="scss">
  .published-date {
    color: $oxford-blue;
    font-size: rem-calc(11);
    line-height: rem-calc(13);
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Date.vue?a8432ac6